<div class="row empty-state-wrapper">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
    <div class="heading-section">
      @if (currentSection()) {
      <h1>{{ currentSection() | titlecase }}</h1>
      }
    </div>
    <div class="empty-product-state">
      <p class="empty-state-msg">
        We're sorry, no products were found for your applied filter and search query
      </p>
      <p class="empty-state-tips">Try your search again using these tips:</p>
      <ul class="tips-list">
        <li>Double check the spelling. Try varying the spelling.</li>
        <li>Limit the search to one or two words</li>
        <li>
          Be less specific in your wording. Sometimes a more general term will lead you to the
          similar products.
        </li>
      </ul>
      <!-- <div class="row">
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-0">
          <base-empty-state-input></base-empty-state-input>
        </div>
      </div> -->
    </div>
  </div>
</div>
